"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CollectionDefinition = _interopRequireDefault(require("./CollectionDefinition"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PageManager =
/*#__PURE__*/
function (_Backbone$Model) {
  _inherits(PageManager, _Backbone$Model);

  function PageManager() {
    _classCallCheck(this, PageManager);

    return _possibleConstructorReturn(this, _getPrototypeOf(PageManager).apply(this, arguments));
  }

  _createClass(PageManager, [{
    key: "fetchRoomById",
    // page == room, page has views, one of which is the home-page collections collection
    // ref: /v2/libraries/qa/pages
    value: function fetchRoomById() {
      var _this = this;

      var roomId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'home';
      this.url = window.url(window.routes.rest.rooms.get, {
        roomId: roomId
      });
      return new Promise(function (resolve, reject) {
        _this.fetch({
          timeout: 10000,
          success: function success(model, response, options) {
            return resolve(response);
          },
          error: function error(model, response, options) {
            return reject(response);
          }
        });
      });
    }
  }, {
    key: "fetchCampaignById",
    value: function fetchCampaignById(campaignId) {
      return new Promise(function (resolve, reject) {
        $.ajax({
          url: window.url(window.routes.rest.campaigns.get, {
            campaignId: campaignId
          }),
          dataType: 'json',
          timeout: 10000
        }).done(function (response) {
          return resolve(response);
        }).fail(function (jqHXR, textStatus, errorThrown) {
          return reject(jqHXR);
        });
      });
    }
  }, {
    key: "fetchCollectionById",
    value: function fetchCollectionById(collectionId) {
      return new Promise(function (resolve, reject) {
        $.ajax({
          url: window.url(window.routes.rest.collections.getById, {
            id: collectionId
          }),
          dataType: 'json',
          timeout: 10000
        }).done(function (response) {
          return resolve(new _CollectionDefinition["default"](response));
        }).fail(function (jqHXR, textStatus, errorThrown) {
          return reject(jqHXR);
        });
      });
    }
  }, {
    key: "getView",
    value: function getView(viewName) {
      if (!this.isLoaded) {
        return null;
      }

      return (viewName || '').toLowerCase() === 'home' ? _(this.attributes.views).findWhere({
        isDefault: true
      }) : _(this.attributes.views).findWhere({
        name: viewName
      });
    }
  }, {
    key: "getCampaigns",
    value: function getCampaigns() {
      return this.isLoaded && this.attributes.campaigns;
    }
  }, {
    key: "idAttribute",
    get: function get() {
      return 'pageId';
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return !_.isEmpty(this.attributes);
    }
  }]);

  return PageManager;
}(Backbone.Model);

exports["default"] = PageManager;